import "intersection-observer";
import $ from "jquery";
import app, { csl } from "@@assets/scripts/common";
import "@@components/index/pageHeader";
import "@@components/index/contact-form";

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	delete app._GET.sheet;
	app.replaceState(app._GET);
	
	//スクロール位置によってメニューの色を変更する
	const sections = document.querySelectorAll(".nav-target");

	const options = {
		root: null,
		rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
		threshold: 0
	};
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				const tid = entry.target.id;
	
				const curIndex = $(".nav-list").find(".is-active");
				curIndex.removeClass("is-active");
	
				const newIndex = $(".nav-list").find(`a[href$='#${tid}']`);
				newIndex.addClass("is-active");
			}
		});
	}, options);

	sections.forEach(sctn => {
		observer.observe(sctn);
	});
	
});

app.exec();
